import template from './exploreWidgetTabsNg1.jade';

class ExploreWidgetTabsNg1Controller {
  constructor($scope, $filter, $timeout, currentExploreGroup, exploreBenchmarkSnapshotSubject, exploreFilteredSnapshotDataSubject, userExploreConstants) {
    this.currentExploreGroup = currentExploreGroup;
    this.$filter = $filter;
    this.$timeout = $timeout;
    this.userExploreConstants = userExploreConstants;
    this.widgetsData = this.buildEmptyWidgetData();
    this.maxCountriesInWidget = 3;
    this.maxOtherAppsInWidget = 3;

    exploreBenchmarkSnapshotSubject.subscribe((benchmarkSnapshot) => {
      if(benchmarkSnapshot != null) {
        this.setWidgetsBenchmarkValues(benchmarkSnapshot);
        if(benchmarkSnapshot.isNoGroupLoadedAndPristineFilters_fresh) {
          this.setWidgetsValues(benchmarkSnapshot);
        }
      }
    });

    exploreFilteredSnapshotDataSubject.subscribe((filteredExploreSnapshot) => {
      if(filteredExploreSnapshot != null) {
        this.setWidgetsValues(filteredExploreSnapshot);
      }
    });

    this.exploreGroup;
    this.activeChartsTab = 'demographics';
    this.incomeRanges = [
      "Over $100k",
      "$75k - $100k",
      "$60k - $75k",
      "$40k - $60k",
      "$25k - $40k",
      "Under $25k"
    ];

    this.top50Countries = [
      {code:"US",image:"https://dummyimage.com/300x200/067020/000000"},{code:"RU",image:"https://dummyimage.com/300x200/cc0000/000000"},{code:"DE",image:"https://dummyimage.com/300x200/fa4f00/000000"},{code:"BR",image:"https://dummyimage.com/300x200/067020/000000"},{code:"GB",image:"https://dummyimage.com/300x200/fa4f00/000000"},
      {code:"CN",image:"https://dummyimage.com/300x200/cc0000/000000"},{code:"FR",image:"https://dummyimage.com/300x200/fa4f00/000000"},{code:"TR",image:"https://dummyimage.com/300x200/cc0000/000000"},{code:"MX",image:"https://dummyimage.com/300x200/067020/000000"},{code:"IN",image:"https://dummyimage.com/300x200/fa4f00/000000"},
      {code:"IT",image:""},{code:"CA",image:""},{code:"VN",image:""},{code:"JP",image:""},{code:"ID",image:""},
      {code:"ES",image:""},{code:"TH",image:""},{code:"UA",image:""},{code:"PL",image:""},{code:"PH",image:""},
      {code:"AU",image:""},{code:"NL",image:""},{code:"KR",image:""},{code:"AR",image:""},{code:"SA",image:""},
      {code:"CO",image:""},{code:"MY",image:""},{code:"TW",image:""},{code:"RO",image:""},{code:"SE",image:""},
      {code:"CZ",image:""},{code:"CL",image:""},{code:"EG",image:""},{code:"PT",image:""},{code:"BE",image:""},
      {code:"KZ",image:""},{code:"DK",image:""},{code:"CH",image:""},{code:"AT",image:""},{code:"GR",image:""},
      {code:"HU",image:""},{code:"BY",image:""},{code:"IL",image:""},{code:"IR",image:""},{code:"PE",image:""},
      {code:"PK",image:""},{code:"AE",image:""},{code:"IQ",image:""},{code:"NO",image:""},{code:"ZA",image:""}
    ];

    this.top50Apps = [
      {bundleId:"com.outfit7.mytalkingtomfree",name:"My Talking Tom",icon:"https://lh3.googleusercontent.com/S9h-Qbx5vGCnKRnpEIkn8SXUZ_eDNgnn5uCsHepPnnD-oiH0ham7WIPUK_qs8Vv_-BE=w300"},
      {bundleId:"com.cmplay.tiles2",name:"Piano Tiles 2 (Don't Tap...2)",icon:"https://lh3.googleusercontent.com/2TVVGIJe5F-Fr1pAqikpvizmhk6veLjmia9jRNX_vitcvDDBooI6lVMMcgR7cMOkIPU=w300"},
      {bundleId:"com.kiloo.subwaysurf",name:"Subway Surfers",icon:"https://lh3.googleusercontent.com/agEcZNXtaO1WXroCx4VVgTmF3wXgo9wHeScGwngrYYSf3mYBPvw8xsotI5Z9uMRdmBs=w300"},
      {bundleId:"com.outfit7.mytalkingangelafree",name:"My Talking Angela",icon:"https://lh3.googleusercontent.com/2PNYe4eRenukTULzqd7yIB1ElmmMAD8Jvt7zwQ5Hq6o4QXJ1bGgOpRCCjAm-fbvGRrE=w300"},
      {bundleId:"com.supercell.clashofclans",name:"Clash of Clans",icon:"https://lh6.ggpht.com/1eVPA6Iukw-F4i5xq1ZWicaKBzmprLGw98YhdG20E-wlsHHg3PcKJqbY_fWLdJeGRw=w300"},
      {bundleId:"com.supercell.clashroyale",name:"Clash Royale",icon:"https://lh3.googleusercontent.com/K-MNjDiO2WwRNwJqPZu8Wd5eOmFEjLYkEEgjZlv35hTiua_VylRPb04Lig3YZXLERvI=w300"},
      {bundleId:"com.mojang.minecraftpe",name:"Minecraft: Pocket Edition",icon:"https://lh3.googleusercontent.com/30koN0eGl-LHqvUZrCj9HT4qVPQdvN508p2wuhaWUnqKeCp6nrs9QW8v6IVGvGNauA=w300"},
      {bundleId:"657500465",name:"My Talking Tom",icon:"https://lh3.googleusercontent.com/S9h-Qbx5vGCnKRnpEIkn8SXUZ_eDNgnn5uCsHepPnnD-oiH0ham7WIPUK_qs8Vv_-BE=w300"},
      {bundleId:"com.fingersoft.hillclimb",name:"Hill Climb Racing",icon:"https://lh6.ggpht.com/N0UxhBVUmx8s7y3F7Kqre2AcpXyPDKAp8nHjiPPoOONc_sfugHCYMjBpbUKCMlK_XUs=w300"},
      {bundleId:"com.outfit7.talkingtomgoldrun",name:"Outfit7",icon:"https://lh3.googleusercontent.com/F4zr292Jfxe10dv0ggZooTYsho0TROLbAeY8QR-6FJaW-WWwCwndl7SiFcxkfheA1hA=w300"},
      {bundleId:"com.miniclip.eightballpool",name:"8 Ball Pool",icon:"https://lh4.ggpht.com/bfp-gUDal6YKuVIkmA7iNR_-Tf4yaTXOyKaK8r1C2whC9APYiRcvmlM3ub9TxLBMw3KT=w300"},
      {bundleId:"com.miniclip.agar.io",name:"Agar.io",icon:"https://lh3.googleusercontent.com/P-7CZ6UljBidkrQnoCe8I4V_p3g7-GqrnwvqLyDa25aeojHSm7NRMLoNcAfnGdk0wV8=w300"},
      {bundleId:"com.firsttouchgames.dls3",name:"Dream League Soccer 2016",icon:"https://lh3.googleusercontent.com/UabgP6TyWZC-kZiijhSB_T_cLK1e97L6xEIt5N_p20UoVN7K20YUjRGS5S3R9sNpFRs=w300"},
      {bundleId:"847492141",name:"Score! Hero",icon:"http://is5.mzstatic.com/image/thumb/Purple71/v4/a1/b2/b1/a1b2b120-1ec1-d334-781b-4a1f57cdeee8/mzl.ibbfdeyk.png/100x100bb-85.jpg"},
      {bundleId:"648668184",name:"Happy Wheels",icon:"http://is1.mzstatic.com/image/thumb/Purple60/v4/69/a4/76/69a476de-e700-9321-62b3-72b3b61b7033/mzl.ldpbtqda.png/100x100bb-85.jpg"},
      {bundleId:"com.miniclip.archery",name:"Archery King",icon:"https://lh3.googleusercontent.com/hkvb61UQi4zjpnf6bT13hth7ly8PlOPLVgaJvrYCMGv_BweqhiXW8_ALyeLddOnQrSQ=w300"},
      {bundleId:"com.fgol.HungrySharkEvolution",name:"Hungry Shark Evolution",icon:"https://lh3.googleusercontent.com/tJ-0ivx3keVsAxmDssL4zm_NHquMCb53pFxlkBccAF51RXym6PkrXingcw03OLDIPQ=w300"},
      {bundleId:"com.pixel.gun3d",name:"Pixel Gun 3D (Pocket Edition)",icon:"https://lh3.googleusercontent.com/K0_j1Swx-Rlg0YEiy2SYtaFxCfgNPMH5NcWTLiyRhc40KFTeFOd8k3HkXbRw-lABGCw=w300"},
      {bundleId:"com.firsttouchgames.story",name:"Score! Hero",icon:"https://lh3.googleusercontent.com/ijBs8VrvVc71uYHnZgv_MoOJosndrwzMqTmsp74rd9MoPQQVjQdr9ug0FuuDUvcUD7U=w300"},
      {bundleId:"com.outerminds.tubular",name:"PewDiePie's Tuber Simulator",icon:"https://lh3.googleusercontent.com/Zg5m7aK5drro5fV6HtwhPYevTAX8hy5Y_BIcTZeP4v08XvxyyoVpMtLzqQq8bWSty0pf=w300"},
      {bundleId:"1053533457",name:"Color Switch",icon:"http://is4.mzstatic.com/image/thumb/Purple122/v4/f0/bd/52/f0bd52a3-d969-0dee-ac43-afc28ef83b60/source/60x60bb.jpg"},
      {bundleId:"1233739175",name:"Balls VS Blocks",icon:"http://is5.mzstatic.com/image/thumb/Purple127/v4/8d/f8/21/8df8210d-9a65-8d52-0869-cf4ac30a8199/pr_source.png/100x100bb-85.jpg"},
      {bundleId:"1089336971",name:"Talking Tom Gold Run",icon:"http://is3.mzstatic.com/image/thumb/Purple18/v4/74/15/f4/7415f490-1fc9-928e-d1bc-0d1e6e24b7ad/pr_source.png/100x100bb-85.jpg"},
      {bundleId:"com.king.candycrushsaga",name:"Candy Crush Saga",icon:"https://lh5.ggpht.com/81M05pEyFiOqKt8CashUoz66iJAhL-3PHHbAil108QkU9sKeVZBuZaNJiV7b0gZ2GFU=w300"},
      {bundleId:"1171814682",name:"Paper.io",icon:"http://is5.mzstatic.com/image/thumb/Purple71/v4/ab/7a/c3/ab7ac3d4-9534-8e8b-b62a-90f5998c1bb6/source/60x60bb.jpg"},
      {bundleId:"com.skgames.trafficrider",name:"Traffic Rider",icon:"https://lh3.googleusercontent.com/waNXuksTMUa1iPKdHpnCCuwWweFl_4h18vCQdpDwLf8c3_Fg77q0rfYiHoh4lUM7Xg=w300"},
      {bundleId:"535500008",name:"Hungry Shark Evolution",icon:"http://is2.mzstatic.com/image/thumb/Purple22/v4/42/e1/00/42e100c1-6688-a1a1-8d8d-48d897545cd5/mzl.jvwshcvy.jpg/100x100bb-85.jpg"},
      {bundleId:"909351158",name:"My Talking Angela",icon:"http://is5.mzstatic.com/image/thumb/Purple62/v4/e1/89/a7/e189a785-9d52-3764-9a9e-11df4b0dc3d6/mzl.zcarjjmz.png/100x100bb-85.jpg"},
      {bundleId:"1010704842",name:"Dream League Soccer 2017",icon:"http://is4.mzstatic.com/image/thumb/Purple111/v4/e6/a3/99/e6a399ca-9334-ee6a-48d6-b5f1cfa417b6/pr_source.png/100x100bb-85.jpg"},
      {bundleId:"com.miniclip.bowmasters",name:"Bowmasters",icon:"https://lh3.googleusercontent.com/14_Tce0JmfM_yD8WY21XIi-FQeh3KXiCUZ2SD1LI96nEtqIi25KJdzz8CvAP-vGMI9gD=w300"},
      {bundleId:"com.izmo.onlinekafatopu",name:"Online Head Ball",icon:"https://lh3.googleusercontent.com/AO9YyqO4mpez1FVNG9GVeb-xcZ7TtimEUuB33uJLCj6Oe4NVMQ4ZWICIeGDFXvCsjA=w300"},
      {bundleId:"net.mobigame.zombietsunami",name:"Zombie Tsunami",icon:"https://lh3.googleusercontent.com/qwyScmwjQPpbjZu9FWW5n9ipC_6njYmILhOxvJBKPanaNhh8UHHjOIrPMlLeNup4Lgg=w300"},
      {bundleId:"1137673647",name:"Six!",icon:"http://is2.mzstatic.com/image/thumb/Purple62/v4/00/0d/3a/000d3a55-1c91-ea6d-f61b-6ba2c141e8e6/mzl.twzsjhcj.png/100x100bb-85.jpg"},
      {bundleId:"com.rovio.angrybirds",name:"Angry Birds",icon:"https://lh3.googleusercontent.com/LElKGzPR86exMJtlb_spB25qBtCPXF5lS14clCapqkzEe-dOr8JPQ3LqDpvfaHyMBA=w300"},
      {bundleId:"1046846443",name:"Hungry Shark World",icon:"http://is1.mzstatic.com/image/thumb/Purple111/v4/64/5a/34/645a341f-706f-7405-0817-fad859cb0a44/pr_source.png/100x100bb-85.jpg"},
      {bundleId:"com.nekki.shadowfight",name:"Shadow Fight 2",icon:"https://lh3.googleusercontent.com/m9Ca_WsADK-TylhJ7YrcQrZBpEzRaJKI4sTxL4jGu57JoXtfUt_xJIKyb_MKFzwVLpQ=w300"},
      {bundleId:"com.fingersoft.hcr2",name:"Hill Climb Racing 2",icon:"https://lh3.googleusercontent.com/sRrQVqfTjyjJU6Wf-tfWpXW3fgEvYhCUwWlB0CkiTo23KCHtfFbDjHdGN50lP9XeAVSA=w300"},
      {bundleId:"610391947",name:"Asphalt 8: Airborne",icon:"http://is3.mzstatic.com/image/thumb/Purple20/v4/ad/16/d6/ad16d65c-a015-b462-c362-bbffe096381d/pr_source.jpg/100x100bb-85.jpg"},
      {bundleId:"com.motionvolt.flipdiving",name:"Flip Diving",icon:"https://lh3.googleusercontent.com/D69bMybkRpm-tWa2nRFIQ-8tfG-qyTdTAV_EYRTY4Ghy94AV6t4ekUTS0p1FEfeXxyzD=w300"},
      {bundleId:"com.playrix.gardenscapes",name:"Gardenscapes - New Acres",icon:"https://lh3.googleusercontent.com/BJa2yQgPLL2nU6pl2X1ns6Olf2aC3E1TgUIpOBz-IacIPW_smC5l-tpqt-fvEC_CMBw=w300"},
      {bundleId:"com.rovio.baba",name:"Angry Birds 2",icon:"https://lh3.googleusercontent.com/3VmsUhS7-ZrimjA2x41ZIEYHuRyuXeL698uZTokDA5eRXpgtwDHjy6CgZOvSfA5twg=w300"},
      {bundleId:"1045516045",name:"Flip Diving",icon:"http://is4.mzstatic.com/image/thumb/Purple111/v4/e1/28/01/e128011f-b05f-6c3d-3096-630f3ecceb83/source/60x60bb.jpg"},
      {bundleId:"com.gameloft.android.ANMP.GloftDOHM",name:"Dragon Mania Legends",icon:"https://lh3.googleusercontent.com/6pcqEiMezHL0rkRZvy9oVtRC55BZDUBXCChPY45ehQUOvxh8EJ4-DXvPckCvLqLyl-s=w300"},
      {bundleId:"995999703",name:"Agar.io",icon:"http://is5.mzstatic.com/image/thumb/Purple18/v4/bd/99/ba/bd99ba0a-cd26-e374-db0e-faf3eefe74c5/mzl.ucfraxpl.png/100x100bb-85.jpg"},
      {bundleId:"com.miniclip.plagueinc",name:"Plague Inc.",icon:"https://lh5.ggpht.com/euts6pXFd_m0wFcw8jXtLt_7y7DY3ziJfoZ-5EK_GbLbhLR60NVe8FFtpaxch298Q9b3=w300"},
      {bundleId:"512939461",name:"Subway Surfers",icon:"http://is1.mzstatic.com/image/thumb/Purple71/v4/75/ee/e7/75eee706-e442-2451-e74a-335396bfd0d5/source/60x60bb.jpg"},
      {bundleId:"571393580",name:"Gangstar Vegas",icon:"http://is3.mzstatic.com/image/thumb/Purple62/v4/1d/5b/75/1d5b75bf-3747-e45b-48ce-968fbf0bfc5c/pr_source.jpg/100x100bb-85.jpg"},
      {bundleId:"com.etermax.preguntados.lite",name:"Trivia Crack",icon:"https://lh3.googleusercontent.com/t-W-PozIRnoZdZFS-5GL9VGWRfquJc6U84C5dR47Ud3o5nUWDj6jz3vJqAnliNTBFs8=w300"},
      {bundleId:"com.bigduckgames.flow",name:"Flow Free",icon:"https://lh3.ggpht.com/W4Q8dd8zjpdYe1KyV2t56QjJ_qgq299FzyGs4sZpFl50-vJ2SFNjM3cA1BGU32jqRp0=w300"},
      {bundleId:"com.ninjakiwi.bloonstdbattles",name:"Bloons TD Battles",icon:"https://lh3.googleusercontent.com/qXHvd7OIFk1pFmUpTWp-wIKOAAixREY1eIhTgwzFZXKkNhtPCEik71bau9h5JK68eQ=w300"}
    ];

    this.topGenres = [
      'Books',
      'Business',
      'Catalogs',
      'Education',
      'Entertainment',
      'Finance',
      'Food & Drink',
      'Games',
      'Action',
      'Adventure',
      'Arcade',
      'Board',
      'Card',
      'Casino',
      'Dice',
      'Educational',
      'Family',
      'Kids',
      'Music',
      'Puzzle',
      'Racing',
      'Role Playing',
      'Simulation',
      'Sports',
      'Strategy',
      'Trivia',
      'Word',
      'Health & Fitness',
      'Lifestyle',
      'Medical',
      'Music',
      'Navigation',
      'News',
      'Photo & Video',
      'Productivity',
      'Reference',
      'Social Networking',
      'Sports',
      'Travel',
      'Utilities',
      'Weather'
    ];

    // TODO it would be nice to use the tabs with an observable instead of watching the value
    // Anyway we should prevent double API calls when this component gets initialized. It happens because triggered by watch and observable
    $scope.$watch('vm.activeChartsTab', (newVal) => {

      // this is to refresh data for genres tag cloud in order to make it re-render.
      // otherwise all elements are collapsed
      if(newVal=='activity') {
        let playedGenresDataCopy = _.clone(this.widgetsData.activity.played_genres.data);
        this.widgetsData.activity.played_genres.data = [];
        this.$timeout(() => {
          this.widgetsData.activity.played_genres.data = playedGenresDataCopy;
        }, 0);

      }
    });

    currentExploreGroup.subscribe((group) => {
      if(group != null) {
        this.exploreGroup = group;
      }
    });
  }

  setWidgetsValues(snapshot) {
    this.widgetsData.activity.avg_active_days.value = snapshot.active_days;
    this.widgetsData.activity.avg_sessions_per_day.value = snapshot.daily_app_engagement;
    this.widgetsData.activity.played_genres.data = _.map(snapshot.genres, (genre) => {
      return {text: genre.genre, weight: genre.value}
    });
    this.widgetsData.activity.apps.images = this.deserializeOtherAppsSnapshot(snapshot.other_apps);
    this.widgetsData.activity.apps_average.value = snapshot.number_of_apps;

    this.widgetsData.payment.paying.value = snapshot.payers;
    this.widgetsData.payment.revenue.arpu = snapshot.arpdau;
    this.widgetsData.payment.revenue.arppu = snapshot.arppu;
    this.widgetsData.payment.conversion_rate.value = snapshot.conversion_rate * 100;
    this.widgetsData.payment.transaction.atpu = snapshot.atpu;
    this.widgetsData.payment.transaction.atppu = snapshot.atppu;

    this.widgetsData.demographics.os.ios_value = snapshot.os.ios;
    this.widgetsData.demographics.os.android_value = snapshot.os.android;
    this.widgetsData.demographics.device.smartphone_value = snapshot.devices.smartphone;
    this.widgetsData.demographics.device.tablet_value = snapshot.devices.tablet;
    this.widgetsData.demographics.countries.images = this.deserializeLocationSnapshot(snapshot.location);
    this.widgetsData.demographics.gender.male_value = snapshot.gender.male;
    this.widgetsData.demographics.gender.female_value = snapshot.gender.female;
    this.widgetsData.demographics.age.images = this.deserializeAgeSnapshot(snapshot.age);
    // this.widgetsData.demographics.income.value = '$' + snapshot.income.from + ' - ' + '$' + snapshot.income.to;
  }

  setWidgetsBenchmarkValues(benchmarkSnapshot) {
    this.widgetsData.activity.avg_active_days.benchmark_value = benchmarkSnapshot.active_days;
    this.widgetsData.activity.avg_sessions_per_day.benchmark_value = benchmarkSnapshot.daily_app_engagement;
    this.widgetsData.activity.apps.images = this.deserializeOtherAppsSnapshot(benchmarkSnapshot.other_apps);
    this.widgetsData.activity.apps_average.benchmark_value = benchmarkSnapshot.number_of_apps;

    this.widgetsData.payment.paying.benchmark_value = benchmarkSnapshot.payers;
    this.widgetsData.payment.revenue.arpu_benchmark = benchmarkSnapshot.arpdau;
    this.widgetsData.payment.revenue.arppu_benchmark = benchmarkSnapshot.arppu;
    this.widgetsData.payment.conversion_rate.benchmark_value = benchmarkSnapshot.conversion_rate * 100;
    this.widgetsData.payment.transaction.atpu_benchmark = benchmarkSnapshot.atpu;
    this.widgetsData.payment.transaction.atppu_benchmark = benchmarkSnapshot.atppu;

    this.widgetsData.demographics.os.ios_benchmark = benchmarkSnapshot.os.ios;
    this.widgetsData.demographics.os.android_benchmark = benchmarkSnapshot.os.android;
    this.widgetsData.demographics.device.smartphone_benchmark = benchmarkSnapshot.devices.smartphone;
    this.widgetsData.demographics.device.tablet_benchmark = benchmarkSnapshot.devices.tablet;
    this.widgetsData.demographics.countries.images = this.deserializeLocationSnapshot(benchmarkSnapshot.location);
    this.widgetsData.demographics.gender.male_benchmark = benchmarkSnapshot.gender.male;
    this.widgetsData.demographics.gender.female_benchmark = benchmarkSnapshot.gender.female;
    this.widgetsData.demographics.age.images = this.deserializeAgeSnapshot(benchmarkSnapshot.age);
    // this.widgetsData.demographics.income.benchmark_value = '$' + benchmarkSnapshot.income.from + ' - ' + '$' + benchmarkSnapshot.income.to;
  }

  deserializeOtherAppsSnapshot(otherAppsSnapshot) {
    let ordereOtherAppsArray = _.sortBy(otherAppsSnapshot, 'value').reverse();
    let topOtherAppsSnapshot = ordereOtherAppsArray.slice(0, this.maxOtherAppsInWidget);
    _.forEach(topOtherAppsSnapshot, (appObject) => {
        appObject.url = appObject.icon;
        appObject.textBold = this.$filter('number')(appObject.value, 1) + "%";
        appObject.text = appObject.app_name;
    });
    return topOtherAppsSnapshot;
  }

  deserializeAgeSnapshot(ageSnapshot) {
    let ageWidgetObjects = [];
    _.forEach(ageSnapshot, (agePergent, age) => {
        let ageWidgetObject = {};
        ageWidgetObject.textBold = this.$filter('number')(agePergent, 1) + "%";
        ageWidgetObject.text = this.userExploreConstants.getAgeBucketStringFromDriudBucket(age);
        ageWidgetObjects.push(ageWidgetObject);
    });
    return ageWidgetObjects;
  }

  deserializeLocationSnapshot(benchmarkLocationSnapshot) {
    let countriesArray = [];
    let topCountriesArray = [];

    _.forOwn(benchmarkLocationSnapshot, (value, countryCode) => {
      countriesArray.push({
        url: "/images/FlagKitSVG/" + countryCode + ".svg",
        value: parseFloat(this.$filter('number')(value, 1)),
        text: countryCode
      });
    });

    let ordereCountriesArray = _.sortBy(countriesArray, 'value').reverse();

    _.forOwn(ordereCountriesArray.splice(0, this.maxCountriesInWidget), (countryObject) => {
        countryObject.textBold = countryObject.value + "%";
        delete countryObject.value;
        topCountriesArray.push(countryObject);
    });

    return topCountriesArray;
  }

  buildEmptyWidgetData() {
    return {
      activity: {
        avg_active_days: {
          value: 0,
          benchmark_value: 0,
          text1: "days"
        },
        avg_sessions_per_day: {
          value: 0,
          benchmark_value: 0,
          text1: "sessions"
        },
        played_genres: {
          data: [
            { text: "", weight: 0 },
            { text: "", weight: 0 },
            { text: "", weight: 0 },
            { text: "", weight: 0 },
            { text: "", weight: 0 }
          ],
          text1: "are the types of apps your users play"
        },
        apps: {
          images: [
            {
              url: "",
              textBold: 0 +"%"
            },
            {
              url: "",
              textBold: 0 +"%"
            },
            {
              url: "",
              textBold: 0 +"%"
            }
          ],
          value: 0,
          text1: "of your users also play these apps"
        },
        apps_average: {
          value: 0,
          benchmark_value: 0,
          text1: "Other Apps"
        }
      },
      payment: {
        paying: {
          value: 0,
          benchmark_value: 0,
          text: "users paid before"
        },
        revenue: {
          arpu: 0,
          arpu_benchmark: 0,
          arpu_text: "AVG. revenue per user",
          arppu: 0,
          arppu_benchmark: 0,
          arppu_text: "AVG. revenue per paying user"
        },
        conversion_rate: {
          value: 0,
          benchmark_value: 0,
          text1: "Conversion Rate"
        },
        transaction: {
          atpu: 0,
          atpu_benchmark: 0,
          atpu_text: "AVG. transactions per user",
          atppu: 0,
          atppu_benchmark: 0,
          atppu_text: "AVG. transactions per paying user"
        }
      },
      demographics: {
        os: {
          ios_value: 0,
          ios_benchmark: 0,
          ios_text: "iOS",
          android_value: 0,
          android_benchmark: 0,
          android_text: "Android"
        },
        device: {
          smartphone_value: 0,
          smartphone_benchmark: 0,
          smartphone_text: "Smartphone",
          tablet_value: 0,
          tablet_benchmark: 0,
          tablet_text: "Tablet"
        },
        countries: {
          images: [
            {
              url: "",
              textBold: 0 +"%",
              text: ""
            },
            {
              url: "",
              textBold: 0 +"%",
              text: ""
            },
            {
              url: "",
              textBold: 0 +"%",
              text: ""
            }
          ]
        },
        gender: {
          male_value: 0,
          male_benchmark: 0,
          male_text: "Male",
          female_value: 0,
          female_benchmark: 0,
          female_text: "Female"
        },
        age: {
          value: 0,
          benchmark_value: 0,
          text: "AVG. User Age"
        },
        income: {
          value: 0,
          benchmark_value: 0,
          text: "AVG. household income"
        }
      }
    };
  }

  getFilteringCoefficient(exploreGroup) {
    return 1;
  }

  getMockValue(minValue, maxValue, exploreGroup) {
    return this.$filter('number')(this.getFilteringCoefficient() * Math.random() * (maxValue - minValue) + minValue, 1);
  }

  getComplementaryPercentageArray2Values() {
    let value1 = this.getMockValue(10, 70);
    return [value1, this.$filter('number')(100 - value1, 1)];
  }

  getComplementaryPercentageArray3Values() {
    let value1 = this.getMockValue(10, 50);
    let value2 = this.getMockValue(10, 100 - value1);
    return [value1, value2, this.$filter('number')(100 - value1 - value2, 1)];
  }

}

let ExploreWidgetTabsNg1Component = {
  template: () => { return template },
  controller: ExploreWidgetTabsNg1Controller,
  controllerAs: 'vm',
  bindings: {
    isNoGroupLoadedAndPristineFilters: '=',
    visualizationMode: '='
  }
};

export default angular.module('app.components.explore.widgets-tabs', [])
  .component('exploreWidgetTabsNg1', ExploreWidgetTabsNg1Component);



/** WEBPACK FOOTER **
 ** ./src/components/explore/exploreWidgetTabsNg1.js
 **/